export const docFilenameExt = ['doc', 'docx', 'xlsx', 'xls', 'pdf', 'ppt', 'pptx']
export const imgFilenameExt = ['jpg', 'jpeg', 'png', 'gif']
export const allFilenameExt = [
  ...docFilenameExt,
  ...imgFilenameExt
]
